<template>
  <div class="view-left">
    <div class="view-top">
      <div class="flex flex-y-center">
        <span class="top-icon iconfont icon-gouwu"></span>
        <span class="top-name">商品列表</span>
        <span class="top-count">({{ list.length }}项)</span>
      </div>
      <div
        class="top-toggle iconfont icon-cebian-left"
        title="收起侧边栏"
        @click="popupToggle"
      ></div>
    </div>
    <div class="view-bottom">
      <div
        :class="{ 'view-item': true, active: index === activeIndex }"
        v-for="(item, index) in list"
        :key="index"
        @click="itemToggle(index)"
      >
        <span v-if="item.name" class="item-name">{{ item.name }}</span>
        <span v-if="item.spec" class="item-spec">({{ item.spec }})</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    itemToggle(index) {
      this.$emit('update:activeIndex', index)
    },
    popupToggle() {
      this.$emit('toggle')
    }
  }
}
</script>

<style lang="less" scoped>
.view-left {
  position: relative;
  top: 0;
  bottom: 0;
  width: 160px;
  background: @colorWhite;
  border: @border;
  margin-right: -1px;
  .view-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    line-height: 28px;
    background: @colorGrayF;
    border-bottom: @border;
    .top-icon {
      font-size: 20px;
    }
    .top-name {
      font-size: 14px;
    }
    .top-count {
      color: @colorGrayLight;
    }
    .top-toggle {
      padding: 0 6px;
      border-radius: 3px;
      cursor: pointer;
      &:hover {
        color: @colorWhite;
        background: @colorBlue;
      }
    }
  }
  .view-bottom {
    position: absolute;
    top: 39px;
    bottom: 0;
    width: 100%;
    overflow-y: auto;
    .scroll-bar();
    .view-item {
      display: flex;
      flex-direction: column;
      padding: 5px;
      cursor: pointer;
      border-bottom: @border;
      &:hover,
      &.active {
        color: @colorWhite;
        background: @colorBlue;
      }
      .item-name {
        font-weight: bold;
      }
      .item-spec {
        margin-top: 2px;
      }
    }
  }
}
</style>
